const servers = {
    dev: 'https://synergon-admin-api-dev.herokuapp.com/',
    prod: 'https://synergon-admin-api.herokuapp.com/',
    local: 'http://localhost:5000'
}

export const URL = process.env.API_URL || servers.prod

